import React from 'react';
import { Grid, Typography } from '@mui/material';
import { AutocompleteInput } from 'react-admin';
import { merchantCategoryCodeChoices } from '../../../constants/merchantCategoryCode';

const MerchantCategoryCode = () => (
  <Grid container spacing={10}>
    <Grid size={12}>
      <Typography
        color="#646464"
        variant="h6"
      >
        Merchant Category Code
      </Typography>
    </Grid>
    <Grid
      container
      spacing={4}
      size={{
        xs: 12,
        md: 6,
      }}
    >
      <AutocompleteInput
        fullWidth
        choices={merchantCategoryCodeChoices}
        source="value"
      />
    </Grid>
  </Grid>
);

export default MerchantCategoryCode;
